<template>
  <div class="default">
    <div>
      <div class="img">
        <img src="@/assets/default/vcy_pic_404.png" />
      </div>
      <div class="message">
        <div class="title">当前页面不存在</div>
        <div class="tip">404</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "l404",
};
</script>

<style lang="less" scoped></style>
